import React, { forwardRef, useEffect, useState } from 'react'
import { Backdrop, Box, Card, CircularProgress, Grid, Icon, Modal, Typography } from '@material-ui/core';
import { useParams } from "react-router-dom";
import MaterialTable from '@material-table/core';
import { tableIcons, tableLocalization } from '../../../@jumbo/constants/TableConstants';
import axios_instance from '../../../services/auth/jwt/config';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import { Delete, Edit, Search } from '@material-ui/icons';
import DialogVagaForm from './DialogVagaForm';
import moment from 'moment';
import sweetAlert from '../../../f5/utils/sweetAlert';

export type VagaType = {
    id: number;
    titulo: string;
    empresa: string | null;
    confidencial: boolean | null;
    codigo: string;
    descricao: string;
    sexo: string;
    salario: string;
    escolaridade: string | null;
    exp: string | null;
    exptime: string | null;
    publicacao: string | null;
    limite: string;
    visivel: number;
    carga_horaria: string;
    vagas: number;
    obs: string | null;
    created_at: string;
    updated_at: string;
    emp__status_id: number;
    local_type?: string;
    local_id?: number;
    emp__vaga_id: number | null;
    status_interno?: string;
    status?: {
        id: number;
        nome: string;
        interno: string;
        created_at: string;
        updated_at: string;
    };
};

function VagasIndex({ ...props }) {
    const [data, setData] = useState<VagaType[]>([])
    const [modo, setModo] = useState(1)
    const [success, setSuccess] = useState({ has: false, message: '' })
    const [loading, setLoading] = useState({ is: false, message: '' })
    const [error, setError] = useState({ has: false, message: '' })
    const [dialogState, setDialogState] = useState<{ open: boolean, mode: 'create' | 'edit' | 'show' }>({ open: false, mode: 'create' })
    const [editing, setEditing] = useState<VagaType>({
        id: 0,
        titulo: '',
        empresa: null,
        confidencial: null,
        codigo: '',
        descricao: '',
        sexo: '',
        salario: '',
        escolaridade: null,
        exp: null,
        exptime: null,
        publicacao: null,
        limite: moment().format('YYYY-MM-DD'),
        visivel: 1,
        carga_horaria: '0',
        vagas: 1,
        obs: null,
        created_at: '',
        updated_at: '',
        emp__status_id: 0,
        emp__vaga_id: null,
    })
    const [count, setCount] = useState({
        total: 0,
        aberta: 0,
        encerrada: 0,
        cancelada: 0,
    })

    const params = useParams<{ modo: string, local: string }>()

    useEffect(() => {
        onLoad()
    }, [params, modo])

    useEffect(() => {
        loadCounters()
    }, [params])

    const onLoad = () => {
        let filter = '';
        switch (modo) {
            case 4:
                filter = `/filter/cancelada`
                break;
            case 3:
                filter = `/filter/encerrada`
                break;
            case 2:
                filter = `/filter/aberta`
                break;
            case 1:
            default:
                filter = ``
                break;
        }
        setLoading({ is: true, message: 'Carregando...' })
        axios_instance.get<{ success: boolean, message: string, items: any[] }>(`empregos/${params.modo}/${params.local}/vagasimples${filter}`).then((response) => {
            const r = response.data
            if (r.success) {
                setData(r?.items ?? [])
            }
        }).catch(() => {
        }).finally(() => {
            setLoading({ is: false, message: '' })
        })
    }

    const loadCounters = () => {
        axios_instance.get<{ success: true, message: string, total: number, aberta: number, encerrada: number, cancelada: number }>(`empregos/${params.modo}/${params.local}/vagasimples/counter`).then((response) => {
            const r = response.data
            if (r.success) {
                setCount({
                    total: r.total,
                    aberta: r.aberta,
                    encerrada: r.encerrada,
                    cancelada: r.cancelada,
                })
            }
        }).catch(() => { })
    }

    const handlePanel = (id: number) => {
        if (id === 5) {
            setEditing({
                id: 0,
                titulo: '',
                empresa: null,
                confidencial: null,
                codigo: '',
                descricao: '',
                sexo: '',
                salario: '',
                escolaridade: null,
                exp: null,
                exptime: null,
                publicacao: null,
                limite: moment().format('YYYY-MM-DD'),
                visivel: 1,
                carga_horaria: '0',
                vagas: 1,
                obs: null,
                created_at: '',
                updated_at: '',
                emp__status_id: 0,
                emp__vaga_id: null,
            })
            setDialogState({ open: true, mode: 'create' })
        } else {
            setModo(id)
        }
    }

    const onDelete = (id: number) => {
        setLoading({ is: true, message: 'Carregando...' })
        var form = {
            id: id
        }
        axios_instance.post<{ success: boolean, message: string }>(`empregos/${params.modo}/${params.local}/vagasimples/cancelar`, form).then((response) => {
            const r = response.data
            if (r.success) {
                sweetAlert('success', 'Sucesso', r?.message ?? 'Vaga cancelada com sucesso!', () => {
                    onLoad()
                })
            } else {
                sweetAlert('error', 'Erro', r?.message ?? 'Erro ao cancelar a vaga.')
            }
        }).catch(() => {
            sweetAlert('error', 'Erro', 'Erro ao cancelar a vaga!')
        }).finally(() => {
            setLoading({ is: false, message: '' })
        })
    }
    const onClose = (reload = false) => {
        setDialogState({ open: false, mode: 'create' })
        if (reload) {
            onLoad()
        }
    }

    let counters = [
        { color: 'blue', icon: 'business-center', name: 'Vagas', count: count.total, id: 1 },
        { color: 'green', icon: 'folder-open', name: 'Abertas', count: count.aberta, id: 2 },
        { color: 'orange', icon: 'archive', name: 'Encerradas', count: count.encerrada, id: 3 },
        { color: 'red', icon: 'clear', name: 'Canceladas', count: count.cancelada, id: 4 },
        { color: 'limegreen', icon: 'add', type: 'add', name: 'Adicionar nova vaga', count: -1, id: 5 }
    ]

    // @ts-ignore
    return <PageContainer>
        <Box>
            <Backdrop open={loading.is} style={{ zIndex: 1105 }}>
                <Box display="flex" justifyContent="center" alignItems="center" height="100%" color="white">
                    <CircularProgress />
                    <Typography variant="h6" style={{ marginLeft: 10 }}>{loading.message}</Typography>
                </Box>
            </Backdrop>
            <Grid container spacing={2}>
                {counters.map(item => <Grid item key={item.id} xs={item.type === 'add' ? 4 : 2} style={{ backgroundColor: item.id === modo ? '#FF751888' : '', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                    <Card onClick={() => handlePanel(item.id)} style={{ cursor: 'pointer', background: item.color, margin: '1rem', padding: '1rem', color: 'white' }}>
                        <Box alignItems="center" display='flex' flexWrap="nowrap" py={{ lg: 2 }}>
                            <Box mr={3}>
                                <Icon fontSize="large">{item.icon}</Icon>
                            </Box>
                            {item.count > -1 ? <Box>
                                <Box mb={1}><Typography variant='h1'>{item.count}</Typography></Box>
                                <Typography>{item.name}</Typography>
                            </Box> : <Box>
                                <Box mb={1}><Typography variant='h1'>{item.name}</Typography></Box>
                            </Box>}
                        </Box>
                    </Card>
                </Grid>)}
            </Grid>
            <MaterialTable
                title='Vagas de Emprego'
                icons={tableIcons}
                localization={tableLocalization}
                data={data}
                options={{
                    actionsColumnIndex: -1,
                    filtering: true,
                    sorting: true,
                }}
                actions={[
                    {
                        icon: () => <Search />,
                        tooltip: 'Visualizar Vaga',
                        onClick: (e, row) => {
                            // @ts-ignore
                            setEditing(row)
                            setDialogState({ open: true, mode: 'show' })
                        },
                    },
                    rowData => ({
                        icon: () => <Edit />,
                        tooltip: 'Editar Vaga',
                        disabled: rowData.status_interno !== 'aberta',
                        hidden: rowData.status_interno !== 'aberta',
                        onClick: (e, row) => {
                            // @ts-ignore
                            setEditing(row)
                            setDialogState({ open: true, mode: 'edit' })
                        }
                    }),
                    rowData => ({
                        icon: () => <Delete />,
                        tooltip: 'Cancelar',
                        disabled: rowData.status_interno !== 'aberta',
                        hidden: rowData.status_interno !== 'aberta',
                        onClick: (e, row) => {
                            sweetAlert('warning', 'Cancelar Vaga', 'Deseja realmente cancelar a vaga?', () => {
                                // @ts-ignore
                                onDelete(row.id)
                            })
                        }
                    }),
                ]}
                columns={[
                    { title: 'Código', field: 'codigo', sorting: false },
                    { title: 'Status', field: 'status_interno', filtering: false },
                    { title: 'Ocupação', field: 'titulo', sorting: true },
                    { title: 'Descrição', field: 'descricao', sorting: true },
                    { title: 'Início', field: 'created_at', type: 'datetime', sorting: true },
                ]}
            />
        </Box>
        <DialogVagaForm
            open={dialogState.open}
            onClose={onClose}
            data={editing}
            mode={dialogState.mode}
            modo={params.modo}
            local={params.local}
            onChange={(field, value) => {
                setEditing({ ...editing, [field]: value })
            }}
        />
    </PageContainer>
}

export default VagasIndex